import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'

import MonthlyViewScreen from 'monthlyview'
import DailyView from 'monthlyview/DailyView'
import DataImportAntd from './DataImportAntd'
import PjmFileCreationAntd from './PjmfileCreationAntd'
import NercFileCreationAntd from './NercFileCreationAntd'
import NercCapacity from 'admin/component/NERCCapacityWithUnit'
import DerateView from './../derate/ViewDerate'
// import DerateProcess from './../derate/ProcessDerate'
import DerateCauseCodeView from './../derate/ViewDerateCauseCode'
// import DerateCauseCodeProcess from './../derate/ProcessDerateCauseCode'
import DerateProcessNyIso from './../derate/ProcessDerateNyIso'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import NonOutageSpill from 'non-outage-spill'

import NEISOFileCreation from '../admin/component/talen/NEISOFileCreation'

export default ({ actionPermits, envConfig }) => {
  const nercUser = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NERC_CAPACITY_USER,
          ScreenPermissions.NERC_CAPACITY_USER_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const monthlyView = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MONTHLY_OPERATION_VIEW],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const dailyView = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DAILY_OPERATION_VIEW],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const dataImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CARDDATA_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const pjmfileCreation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PJM_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const nercFileCreation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NERC_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const derateView = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.DERATE_VIEW,
          ScreenPermissions.DERATE_PROCESS,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const causeCodeDerate = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.DERATE_CAUSECODE_VIEW,
          ScreenPermissions.DERATE_CAUSECODE_PROCESS,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const derateProcessNyIso = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DERATE_PROCESS_NYISO],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const nonOutageSpill = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NON_OUTAGE_SPILL_READ,
          ScreenPermissions.NON_OUTAGE_SPILL_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const neISOFile = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.NEISO_FILE_CREATION],
    matchAny: false,
  })

  return (
    <>
      {nercUser && (
        <Route
          key="nerc-capacity"
          exact
          path="/user-nerc-capacity"
          component={NercCapacity}
        />
      )}
      {dailyView && <Route exact path="/dailyview" component={DailyView} />}
      {monthlyView && (
        <Route exact path="/monthlyview" component={MonthlyViewScreen} />
      )}
      {dataImport && (
        <Route
          key="data-import"
          exact
          path="/data-import-antd"
          component={DataImportAntd}
        />
      )}
      {pjmfileCreation && (
        <Route
          key="pjm-file-import"
          exact
          path="/pjm-file-creation-antd"
          component={PjmFileCreationAntd}
        />
      )}
      {nercFileCreation && (
        <Route
          key="nerc-file-creation"
          exact
          path="/nerc-file-creation-antd"
          component={NercFileCreationAntd}
        />
      )}
      {neISOFile && (
        <Route
          key="neiso-file-creation"
          exact
          path="/file/neiso-file-creation"
          component={NEISOFileCreation}
        />
      )}
      {nonOutageSpill && (
        <Route
          key="non-outage-spill"
          exact
          path="/non-outage-spill"
          component={NonOutageSpill}
        />
      )}
      {derateView && (
        <Route
          key="derate-view"
          exact
          path="/derate-view"
          component={DerateView}
        />
      )}

      {/* {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DERATE_PROCESS],
        matchAny: true,
      }) && (
        <Route
          key="derate-process"
          exact
          path="/derate-process"
          component={DerateProcess}
        />
      )} */}

      {causeCodeDerate && (
        <Route
          key="derate-causecode-view"
          exact
          path="/derate-causecode-view"
          component={DerateCauseCodeView}
        />
      )}

      {derateProcessNyIso && (
        <Route
          key="derate-process-nyiso"
          exact
          path="/derate-process-nyiso"
          component={DerateProcessNyIso}
        />
      )}

      {/* {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DERATE_CAUSECODE_PROCESS],
        matchAny: true,
      }) && (
        <Route
          key="derate-causecode-process"
          exact
          path="/derate-causecode-process"
          component={DerateCauseCodeProcess}
        />
      )} */}
    </>
  )
}
